<app-modal
  [title]="'Rabatte' | trans:'cart/discount-modal/header/title'"
  maxWidth="1200px"
  minWidth="30%"
  width="fit-content"
  [compact]="true"
>
  <ng-template>
    <div class="d-grid gap-12">
      <button
        #btn
        class="button button--quick-action"
        (click)="mandatorParametersMap()[mandatorParameterKeys.CSH_REBATE_ASK_FOR_EMPLOYEE] ? cardCodeInputModalComponent.open(null, 'apply-employee-prices') : applyEmployeePricesToCart(btn)"
      >
        <i class="ri-percent-line"></i>
        {{ 'MA-Preis' | trans:'actions-buttons-modal/buttons/useEmployeePrice.Button' }}
      </button>

      @if (terminalsStore.fixedDiscountPercentage()) {
        <button
          #fixedDiscountBtn
          class="button button--quick-action"
          (click)="applyFixedDiscountToCart(fixedDiscountBtn)"
        >
          <i class="ri-percent-line"></i>
          {{ 'Fixed Discount' | trans:'cart/discount-modal/buttons/fixedDiscount.Button' }}
        </button>
      }

      <button
        class="button button--quick-action"
        (click)="fixedDiscountModalComponent.open({ mode: 'authorized' })"
      >
        <i class="ri-shield-user-line"></i>
        {{ 'Discount (Authorization)' | trans:'cart/discount-modal/buttons/fixedDiscountAuthorization.Button' }}
      </button>

      <button
        class="button button--quick-action"
        (click)="discountCodeInputModalComponent.open()"
        [disabled]="isDiscountCodeActionDisabled()"
      >
        <i class="ri-discount-percent-line"></i>
        {{ 'Discount code' | trans:'cart/discount-modal/buttons/discountCode.Button' }}
      </button>
    </div>
  </ng-template>

  <ng-container modal-buttons>
    <div class="d-flex gap-16 m-t-16 justify-content-flex-end">
      <button
        class="button button--md button--primary-ghost text-uppercase"
        (click)="close()"
      >
        {{ 'Cancel'| trans:'cart/discount-modal/cancel.Button' }}
      </button>
    </div>
  </ng-container>
</app-modal>

<app-card-code-input-modal
  #cardCodeInputModalComponent
  (codeSubmitted)="employeeCardCode = $event.code; applyEmployeePricesToCart();"
/>

<app-fixed-discount-modal
  #fixedDiscountModalComponent
  (discountApplied)="close()"
/>

<app-discount-code-input-modal
  #discountCodeInputModalComponent
  (discountApplied)="close()"
/>
